import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-currency-text',
  templateUrl: './currency-text.component.html',
  styleUrls: ['./currency-text.component.scss']
})
export class CurrencyTextComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
